// Dispatch Lots modal — "Allocate to Dispatch Lot" section visibility
// predicate (Jul 2026, R13 follow-up).
//
// Extracted so the R13-era `!== 'DRAFT'` gate stays gone forever with
// Jest holding the line. The section renders whenever the forecast has
// unallocated capacity — nothing more. Backend endpoints backing this
// section (`GET /forecasts/{id}/dispatch-lots`, `POST /dispatch-lots-v2/
// {id}/add-line`, `POST /dispatch-lots-v2`) are permissive of forecast
// status and only guard on lot status / forecast existence, so the
// frontend predicate matches the backend contract.
//
// Legacy history: pre-R13 the gate was `status !== 'DRAFT'` — DRAFT
// then meant "not-yet-final, don't allocate", CONFIRMED was the
// terminal editable state. R13 collapsed CONFIRMED into DRAFT (edit-
// anytime UX) but this specific gate was never inverted, silently
// locking every post-R13 DRAFT forecast out of allocation. Deleted
// Jul 2026.

/**
 * @param {Object} forecast  Forecast document with `quantity` and optional
 *                           `dispatch_allocated` (units already committed
 *                           to dispatch lots). `status` is deliberately
 *                           NOT read.
 * @returns {boolean}        true if the allocate section should render.
 */
export function shouldShowAllocateSection(forecast) {
  if (!forecast) return false;
  const quantity = Number(forecast.quantity) || 0;
  const allocated = Number(forecast.dispatch_allocated) || 0;
  return quantity - allocated > 0;
}
